import axios from 'axios';
import { URL } from '../url';
import {
  JOIN_WAIT_LIST_SUCCESS,
  JOIN_WAIT_LIST_LOADING,
  JOIN_WAIT_LIST_FAILED,
  CONTACT_US_SUCCESS,
  CONTACT_US_LOADING,
  CONTACT_US_FAILED,
  REQUEST_DEMO_SUCCESS,
  REQUEST_DEMO_LOADING,
  REQUEST_DEMO_FAILED,
  GET_STARTED_SUCCESS,
  GET_STARTED_LOADING,
  GET_STARTED_FAILED,
} from './types';
import { createMessage } from '../messages/messages';
// import { tokenConfig } from "../auth/auth";
import errorHandler from '../errorHandler';

// CONTACT_US
export const contactUs = (name, email, subject, message) => (dispatch) => {
  dispatch({ type: CONTACT_US_LOADING });
  axios
    .post(
      `${URL}/api/customers/contact_us`,
      {
        name,
        email,
        subject,
        message,
      },
      // tokenConfig(getState)
    )
    .then(() => {
      dispatch(createMessage('We have received your message'));
      dispatch({
        type: CONTACT_US_SUCCESS,
      });
    })
    .catch((err) => {
      errorHandler(dispatch, err, CONTACT_US_FAILED, 'Contacting us');
    });
};

// JOIN_WAIT_LIST
export const joinWaitList = (email) => (dispatch) => {
  dispatch({ type: JOIN_WAIT_LIST_LOADING });
  axios
    .post(
      `${URL}/api/customers/join_waitlist`,
      {
        email,
      },
      // tokenConfig(getState)
    )
    .then(() => {
      dispatch(createMessage('Successfully joined waiting list'));
      dispatch({
        type: JOIN_WAIT_LIST_SUCCESS,
      });
    })
    .catch((err) => {
      errorHandler(dispatch, err, JOIN_WAIT_LIST_FAILED, 'Joining wait list');
    });
};

// GET_STARTED
export const getStarted =
  ({ name, phone, email, school_name, number_of_students, message }) =>
  (dispatch) => {
    dispatch({ type: GET_STARTED_LOADING });

    axios
      .post(
        `${URL}/api/customers/get_started`,
        {
          phone,
          name,
          email,
          school_name,
          number_of_students,
          message,
        },
        // tokenConfig(getState)
      )
      .then(() => {
        dispatch(createMessage('Request successfully received. We will get back to you soon.'));
        dispatch({
          type: GET_STARTED_SUCCESS,
        });
      })
      .catch((err) => {
        errorHandler(dispatch, err, GET_STARTED_FAILED, 'Getting started');
      });
  };

// REQUEST_DEMO
export const requestDemo = (first_name, last_name, email) => (dispatch) => {
  dispatch({ type: REQUEST_DEMO_LOADING });

  axios
    .post(
      `${URL}/api/customers/request_demo`,
      {
        last_name,
        first_name,
        email,
      },
      // tokenConfig(getState)
    )
    .then(() => {
      dispatch(
        createMessage(
          'Request for demo successfully received. Please check your email for further action.',
        ),
      );
      dispatch({
        type: REQUEST_DEMO_SUCCESS,
      });
    })
    .catch((err) => {
      errorHandler(dispatch, err, REQUEST_DEMO_FAILED, 'Requesting demo');
    });
};
